module.exports = __webpack_public_path__ + "img/Sponga_mascot_corner.9976a49c.png";